module.exports = __webpack_public_path__ + "img/PROTETOR.4b3ed229.jpg";